import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
          <div className="max-w-xl w-full text-center space-y-4">
            <h1 className="text-3xl font-mystical font-bold bg-gradient-mystic bg-clip-text text-transparent">
              Algo salió mal
            </h1>
            <p className="font-ethereal text-muted-foreground">
              Ocurrió un error al cargar la aplicación.
            </p>
            <pre className="text-xs text-left bg-card/50 border border-border rounded p-4 overflow-auto">
              {this.state.error.message}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 rounded-md bg-gradient-mystic text-primary-foreground font-ethereal"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
